import { createContext } from 'react';

const SingleSelectPopupsContext = createContext({
    gridPopups: null,
    setGridPopups: (values: any) => {},
});

export default SingleSelectPopupsContext;
